module.exports = __webpack_public_path__ + "static/media/plastico.7d10046e.png";